import script from "./ImageCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCanvas.vue?vue&type=script&setup=true&lang=js"

import "./ImageCanvas.vue?vue&type=style&index=0&id=630323b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-630323b0"]])

export default __exports__